<template>
  <footer class="insi-wrapper-footer light-blue darken-4">
    <div class="container">
      <div class="row"></div>
    </div>
    <div class="wrapper-footer__copyright">
      <div class="container">
        <p class="center-align">
          <a href="https://www.banq.qc.ca/politique-de-confidentialite/" target="_blank">
            Confidentialité
          </a>
        </p>
        <p class="center-align">
          © Bibliothèque et Archives nationales du Québec, 2020
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer"
};
</script>
<style lang="scss" scoped>
.insi-wrapper-footer {
  bottom: 0;
  width: 100%;
  min-height: 120px;
  position: absolute;

  .wrapper-footer__copyright {
    p {
      color: white;
      font-size: 1rem;
    }
    a {
      color: white;
      font-size: 1rem;
      font-weight: normal;
      text-decoration: underline;
    }    
  }
}
</style>
